import React from 'react';
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';

import Grid from '@material-ui/core/Grid';
import DashboardCharts from '@jumbo/Dashboards/dashboard/dashboardCharts';
import DashboardVisits from '@jumbo/Dashboards/dashboard/dashboardVisits';

const breadcrumbs = [{ label: <IntlMessages id={'sidebar.main'} />, isActive: true }];

const Dashboard = () => {
  return (
    <PageContainer heading={<IntlMessages id="sidebar.main" />} breadcrumbs={breadcrumbs}>
      <GridContainer>
        <Grid item xs={12}>
          <DashboardCharts />
        </Grid>
        <Grid item xs={12}>
          <DashboardVisits />
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default Dashboard;
